//import * as slick from "./plugins/slick.js";
import * as mfp from "./plugins/mfp.js";
//import * as lazyload from "./plugins/lazyload.js";
import * as masonry from "./plugins/masonry.js";
//import * as vscroll from "./plugins/vscroll.js";

export function init() {
    console.log("init plugins")
    mfp.init();
    masonry.init();
    //lazyload.init();

    init_carousel();
    //masonry.init();
    //vscroll.init();
    // init_galleries();
}

function init_carousel() {
    //slick.init();
}

// export function init_galleries() {
//     jQuery('.popup-video').magnificPopup({
//         type: 'iframe',
//         callbacks: {
//             beforeOpen: function () {
//                 // just a hack that adds mfp-anim class to markup
//                 this.st.image.markup = this.st.image.markup.replace('mfp-content', 'mfp-video mfp-content');
//             }
//         },
//     });

//     jQuery('.popup-gallery').magnificPopup({
//         delegate: '.owl-item:not(.cloned) a, .grid-item:not(.href) a',
//         type: 'image',
//         callbacks: {
//             beforeOpen: function () {
//                 // just a hack that adds mfp-anim class to markup
//                 this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
//                 this.st.mainClass = this.st.el.attr('data-effect');
//             }
//         },
//         tLoading: 'Loading image #%curr%...',
//         mainClass: 'mfp-img-mobile',
//         gallery: {
//             enabled: true,
//             navigateByImgClick: true,
//             preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
//         },
//         image: {
//             tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
//             titleSrc: function (item) {
//                 return item.el.attr('title') + '<small></small>';
//             }
//         }
//     });
// }